import React, { Dispatch, SetStateAction, useEffect, useState } from "react"

import { Provider } from "lib/types/generated/graphql-types"
import { PROVIDER_TYPE } from "lib/types/common"

import { Container, EmptyList, Wrapper } from "components/Ui/Table/Shared.styled"

import ErrorMessage from "../../Ui/Messages/ErrorMessage"
import { CustomPaymentConfigTableRow, getLoadingRow } from "./CustomPaymentConfigTableRow"
import TableBlurLoading from "../../Ui/Table/TableBlurLoading"
import TableHeader from "../../Ui/Table/TableHeader"

type Props = {
  providers: Provider[]
  error: object | undefined
  setEditId?: Dispatch<SetStateAction<string>>
  loading: boolean
}

export const CustomPaymentConfigTable = ({ providers, setEditId, error, loading }: Props) => {
  const [customPaymentProviders, setCustomPaymentProviders] = useState<Provider[]>([])
  useEffect(() => {
    if (providers) {
      setCustomPaymentProviders(providers?.filter((provider) => provider.type === PROVIDER_TYPE.CUSTOM_PAYMENT))
    }
  }, [providers])

  const tableHeader = (
    <TableHeader iconHeader={true}>
      <div>Identifier</div>
      <div>Base url</div>
      <div className="hideOnMediumScreens">Created</div>
      <div className="hideOnMediumScreens">Updated</div>
    </TableHeader>
  )

  if (loading)
    return <TableBlurLoading numberOfRows={2} tableHeader={tableHeader} rows={getLoadingRow()} />

  if (customPaymentProviders?.length < 1)
    return (
      <EmptyList>
        <p> No configurations added</p>
      </EmptyList>
    )
  if (!providers) return null

  return (
    <Wrapper>
      <Container>
        {error && (
          <ErrorMessage
            showRefreshButton
            message={
              <>
                Error loading Custom Payment configurations. Try refreshing the page, or contact{" "}
                <a href="mailto:support@brinkcommerce.com">support</a>.
              </>
            }
          />
        )}
        {tableHeader}
        {[...customPaymentProviders].map((customPaymentProvider) => (
          <CustomPaymentConfigTableRow
            key={customPaymentProvider.id}
            id={customPaymentProvider.id}
            setEditId={setEditId}
          />
        ))}
      </Container>
    </Wrapper>
  )
}
